import { render } from "./ViewsTunnelService.vue?vue&type=template&id=367736be"
import script from "./ViewsTunnelService.vue?vue&type=script&lang=js"
export * from "./ViewsTunnelService.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__